var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBravoTeamLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 0L145 72.5L72.5 145L3.95671e-06 72.5L72.5 0Z",
    fill: "#2F2F39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.858 72.5L72.5 14.1421L14.1421 72.5L72.5 130.858L130.858 72.5ZM72.5 0L3.95671e-06 72.5L72.5 145L145 72.5L72.5 0Z",
    fill: "#C94340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4033 72.5455L73 47.1421L47.5967 72.5455L73 97.9488L98.4033 72.5455ZM73 33L33.4545 72.5455L73 112.091L112.545 72.5455L73 33Z",
    fill: "#C94340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.498 91.4951L91.498 55.5693L55.5723 55.5693L55.5723 91.4951L91.498 91.4951ZM101.498 45.5693L45.5723 45.5693L45.5723 101.495L101.498 101.495L101.498 45.5693Z",
    fill: "#C94340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93 73.5C93 84.8218 83.8218 94 72.5 94C61.1782 94 52 84.8218 52 73.5C52 62.1782 61.1782 53 72.5 53C83.8218 53 93 62.1782 93 73.5Z",
    fill: "#2F2F39"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBravoTeamLogo);
export default __webpack_public_path__ + "static/media/bravo_team_logo.e534416d6a96e04d08350e3c9a3a1c7f.svg";
export { ForwardRef as ReactComponent };